// Aptitude quiz from the legacy application (templates/job-survey.html).
// Option values must match what backend scores against.
export const APTITUDE_QUESTIONS = [
  {
    field: 'when_to_use_google_docs',
    label: 'Which scenario below would a "Google Doc" be most useful for?',
    options: [
      { value: 'search', label: 'Searching the web' },
      { value: 'doctor', label: 'Locating a doctor' },
      { value: 'spreadsheet', label: 'Sharing a spreadsheet with someone' },
    ],
  },
  {
    field: 'carnagie_deli_cross_streets',
    label: 'What were the nearest cross streets to Carnegie Deli (when it was open)?',
    options: [
      { value: '7th_st_and_55th_ave', label: '7th St and 55th Ave' },
      { value: '42nd_', label: '42nd St and Broadway' },
      { value: '7th_ave_and_55th_st', label: '7th Avenue and 55th St' },
    ],
  },
  {
    field: 'finding_a_steakhouse',
    label: 'What website would be the best to use to find the best steakhouse near your home?',
    options: [
      { value: 'bing', label: 'Bing' },
      { value: 'yahoo', label: 'Yahoo' },
      { value: 'yelp', label: 'Yelp' },
      { value: 'ehow', label: 'eHow.com' },
    ],
  },
  {
    field: 'what_program_for_docx',
    label: 'What program opens up .docx files?',
    options: [
      { value: 'Excel', label: 'MS Excel' },
      { value: 'Word', label: 'MS Word' },
      { value: 'Open Office', label: 'Open Office' },
    ],
  },
] as const;

export type AptitudeField = (typeof APTITUDE_QUESTIONS)[number]['field'];

export const GRAMMAR_OPTIONS = [
  { value: 'there', label: 'there' },
  { value: 'their', label: 'their' },
  { value: 'theyre', label: "they're" },
];

export const SAMPLE_TASKS = [
  {
    title: 'Minnesota Bar admission',
    body:
      "I'm an attorney and I've been licensed to practice law in Colorado for 1 year now, but I'm " +
      "thinking of moving to Minnesota. I'd like to know if it's possible to be admitted to the " +
      'Minnesota Bar (i.e. be licensed to practice), without having to take the bar exam over again? ' +
      '(sometimes called admittance without examination) Find out if Minnesota allows that, and what ' +
      'the requirements are. I got a score of 150 on my MBE (a score on my bar exam), would that be ' +
      'enough? Be sure to give the link to where you found this info, and explain any rules you find about this.',
  },
  {
    title: 'Declaration of Independence',
    body:
      "I'm going to be in DC next week and I want to go see the original Declaration of Independence. " +
      'Where is that? Can the public see it? Does it cost anything to visit? What days and hours is it ' +
      'open? Make sure you give me links to the official site of the institution where you find the above information.',
  },
];

export const US_STATES = [
  'AL', 'AK', 'AZ', 'AR', 'CA', 'CO', 'CT', 'DE', 'DC', 'FL', 'GA', 'HI', 'ID', 'IL', 'IN', 'IA',
  'KS', 'KY', 'LA', 'ME', 'MD', 'MA', 'MI', 'MN', 'MS', 'MO', 'MT', 'NE', 'NV', 'NH', 'NJ', 'NM',
  'NY', 'NC', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA',
  'WV', 'WI', 'WY',
];
